import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";

import SettingIcon from "../../Icon-SVG/SettingIcon";
import TrashBucketIcon from "../../Icon-SVG/TrashBucketIcon";

import { RequestDeployInt, RequestDeleteInt } from "../../../store/actions/integrationsActions";

import "./styles.scss";

const AppCard = ({
  cardIcon,
  cardName,
  cardDescription,
  intname,
  setActiveInt,
  includedInLicense,
  openModalHandler,
  messageonly,
}) => {
  const dispatch = useDispatch();

  const action = useSelector((state) => state.integrations.action);
  const checkConfig = useSelector((state) => state.integrations.checkConfig);

  const isInstalled = checkConfig?.[intname];

  const installPod = () => {
    dispatch(RequestDeployInt(intname));
  };

  const deletePod = () => {
    dispatch(RequestDeleteInt(intname));
  };

  return (
    <div className="app-cart">
      <div className="app-cart__item-container">
        <div className="app-cart__item-icon">{cardIcon}</div>

        <p className="app-cart__item-name" onClick={() => openModalHandler(intname)}>
          {cardName}
        </p>

        <p className="app-cart__item-description">{cardDescription}</p>
      </div>

      <div className="app-cart__button-container">
        {!action && !isInstalled && (
          <>
            {messageonly ? (
              <button className="app-cart__button" onClick={() => openModalHandler(intname)}>
                Details
              </button>
            ) : (
              <button
                disabled={!includedInLicense}
                className={classNames("app-cart__button", {
                  "app-cart__button--cant-get": !includedInLicense,
                })}
                onClick={installPod}>
                {!includedInLicense ? "Not Available" : "Get it now"}
              </button>
            )}
          </>
        )}

        {action && <button className="app-cart__button waiting">Handling...</button>}

        {!action && isInstalled && (
          <div className="app-cart__settings-button">
            <button
              title="Config"
              onClick={() => setActiveInt(intname)}
              className="app-cart__settings-button__config app-cart__settings-button-btn">
              <SettingIcon width={20} height={20} color="var(--color-blue)" />
              <span>Config</span>
            </button>

            <button
              title="Delete"
              onClick={deletePod}
              className="app-cart__settings-button__delete app-cart__settings-button-btn">
              <TrashBucketIcon width={20} height={20} color="#E65555" />
              <span>Delete</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AppCard;
